import { HTTPClient } from '../utils/request'

export default {
  chagePassword: ({ params, payload }) => HTTPClient.post(`/change_password/${params._id}`, payload)
}
